import classes from "./ChatNotification.module.scss";

const ChatNotification = ({ data, ariaLabel }) => {
  const text = data.content || "";
  const truncated = text.length > 60 ? text.slice(0, 60) + "..." : text;
  return (
    <div className={classes.notification} aria-label={ariaLabel}>
      <h4>{data.title}</h4>
      <p>{truncated}</p>
      <button onClick={data.handleClick}>Reply</button>
    </div>
  );
};

export default ChatNotification;
